/**
 * @file      FileSystem.Effect.ts
 * @author    Gage Sorrell <gage@sorrell.sh>
 * @copyright (c) 2026 Gage Sorrell
 * @license   MIT
 */
export /** The temporary dummy export for the {@link fs/effect} module. */ const __FileSystem_Dummy_Export: "__FileSystem_Dummy_Export" = "__FileSystem_Dummy_Export" as const;
